import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildApiBaseUrl } from './factura-encabezado-repository';

/**
 * Item de cumplimiento para rectificar transporte.
 * Legacy: RectificarTransporteViewImpl.java — columnas de la tabla.
 */
export interface CumplimientoRectificacion {
  nmconsecutivoCumplimiento: number;
  dscliente: string;
  dsasesor: string;
  feprogramacion: string;
  snpagoTransporteEmpleado: string;
  cdmunicipioOrigen: string;
  cdmunicipioEntrega: string;
  nmconsecutivoCliente: number;
  nmconsecutivoOficina: number;
}

export interface RectificarTransporteResultado {
  exito: boolean;
  mensaje: string;
}

export interface FiltroRectificarTransporte {
  snpagoTransporteEmpleado: string;
  nmconsecutivoCumplimiento?: number;
  dsorden?: string;
  nmconsecutivoBeneficiario?: number;
  nmconsecutivoAsesor?: number;
  feprogramacion?: string;
  cursor?: string;
  size?: number;
  direction?: 'NEXT' | 'PREVIOUS';
}

/**
 * Respuesta paginada (Keyset/Cursor) del listado de cumplimientos para
 * rectificar transporte. Espejo de RectificarTransporteCumplimientoPageResponse
 * del backend (servicios-ms).
 */
export interface RectificarTransporteCumplimientoPageResponse {
  content: CumplimientoRectificacion[];
  totalElements: number;
  nextCursor: string | null;
  previousCursor: string | null;
  hasNext: boolean;
  hasPrevious: boolean;
}

/**
 * Service: Rectificar Transporte en Prefactura.
 * Legacy: RectificarTransporteActivity.java
 */
@Injectable({
  providedIn: 'root'
})
export class RectificarTransporteService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${buildApiBaseUrl(environment.backend.baseUrl)}/servicios/facturas`;

  listarCumplimientos(nmconsecutivoFactura: number, filtro: FiltroRectificarTransporte): Observable<RectificarTransporteCumplimientoPageResponse> {
    let params = new HttpParams()
      .set('snpagoTransporteEmpleado', filtro.snpagoTransporteEmpleado)
      .set('size', (filtro.size ?? 10).toString());

    if (filtro.cursor) {
      params = params.set('cursor', filtro.cursor);
    }
    if (filtro.direction) {
      params = params.set('direction', filtro.direction);
    }
    if (filtro.nmconsecutivoCumplimiento) {
      params = params.set('nmconsecutivoCumplimiento', filtro.nmconsecutivoCumplimiento.toString());
    }
    if (filtro.dsorden) {
      params = params.set('dsorden', filtro.dsorden);
    }
    if (filtro.nmconsecutivoBeneficiario) {
      params = params.set('nmconsecutivoBeneficiario', filtro.nmconsecutivoBeneficiario.toString());
    }
    if (filtro.nmconsecutivoAsesor) {
      params = params.set('nmconsecutivoAsesor', filtro.nmconsecutivoAsesor.toString());
    }
    if (filtro.feprogramacion) {
      params = params.set('feprogramacion', filtro.feprogramacion);
    }

    return this.http.get<RectificarTransporteCumplimientoPageResponse>(
      `${this.baseUrl}/${nmconsecutivoFactura}/rectificar-transporte/cumplimientos`,
      { params }
    );
  }

  anularTransporte(nmconsecutivoFactura: number, cumplimientos: number[]): Observable<RectificarTransporteResultado> {
    return this.http.put<RectificarTransporteResultado>(
      `${this.baseUrl}/${nmconsecutivoFactura}/rectificar-transporte/anular`,
      { cumplimientos }
    );
  }

  asignarTransporte(nmconsecutivoFactura: number, cumplimientos: CumplimientoRectificacion[]): Observable<RectificarTransporteResultado> {
    return this.http.put<RectificarTransporteResultado>(
      `${this.baseUrl}/${nmconsecutivoFactura}/rectificar-transporte/asignar`,
      { cumplimientos }
    );
  }
}
